Ext.define('SA.model.LocationValue.Null', {
    extend: 'SA.model.LocationValue',

    statics: {
        isConformantValue(value) {
            return !value;
        }
    },

    toItem() {
        return this.value;
    },

    toNormalized() {
        return this.value;
    },

    toString() {
        return this.value;
    }
});